<!-- <router-outlet></router-outlet> -->


<div style="position: absolute; top:0; bottom: 0; right: 0; left: 0;">
    <router-outlet></router-outlet>
</div>


<div class="spinner" *ngIf="spinner | async">
    <mat-spinner></mat-spinner>
</div>